import React from "react";
import { useParams } from "react-router-dom";
import { useHospitalById } from "../../../../api/member-management/use-hospital-detail";
import TitlePage from "../../../../components/section/TitlePage/Titlepage";
import HospitalEditForm from "./HospitalEditForm";

function HospitalEditPage() {
  const { id } = useParams();
  const { data } = useHospitalById(id);
  const hospital = data?.data;

  return (
    <>
      <div className="w-3/4">
        <TitlePage title="회원조회 > 회원상세 > 병원 정보 > 병원 정보 변경" />

        <HospitalEditForm id={id} hospital={hospital} />
      </div>
    </>
  );
}

export default HospitalEditPage;
